import { render, staticRenderFns } from "./SheetSettingConfig.vue?vue&type=template&id=0a856f23"
import script from "./SheetSettingConfig.vue?vue&type=script&lang=js"
export * from "./SheetSettingConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports